import { useCallback, useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type Result = ModelHookResult<
	{
		isResponseLong: boolean;
		responseText: string | undefined;
		readMoreLink: string;
	},
	{ handleLinkClick: () => void }
>;

const RESPONSE_LENGTH_THRESHOLD = 140;
export function useDecisionMakerResponse(response: string | undefined): Result {
	const track = useTracking();

	const isResponseLong = useMemo(() => {
		return response ? response.length > RESPONSE_LENGTH_THRESHOLD : false;
	}, [response]);

	const responseText = useMemo(() => {
		return response && response.length > RESPONSE_LENGTH_THRESHOLD
			? `${response.substring(0, RESPONSE_LENGTH_THRESHOLD)}...`
			: response;
	}, [response]);

	// TODO: add redirect link

	const handleLinkClick = useCallback(() => {
		void track('legislative_bodies_read_full_response_click');
	}, [track]);

	return {
		data: { isResponseLong, responseText, readMoreLink: '/' },
		actions: { handleLinkClick },
	};
}
